import { isToProvider, isToStore, isToWorkOrder } from '../../../graphql/utils/transaction-types'
import { Transaction, TransactionEntity } from '../../../graphql'
import { getESTrackHost } from 'config/host'

function render( to: TransactionEntity, { transactionType, toId }: Transaction ) {
	if ( transactionType ) {
		if ( isToStore( transactionType ) || isToProvider( transactionType ) ) {
			return to.name
		}

		if ( isToWorkOrder( transactionType ) ) {
			const url = `${getESTrackHost()}/#/service/work-orders/${toId}/parts`

			return (
				<a href={url} target="_blank" rel="noreferrer">{`WO-${toId}`}</a>
			)
		}
	}

	return ''
}

export default {
	field: 'to',
	name: 'To',
	render,
}
